import {
  GET_PINCODE_START,
  GET_PINCODE_SUCCESS,
  CLEAR_PINCODE_VALUE,
  GET_PINCODE_ERROR,
  GET_SECOND_PINCODE_SUCCESS
} from "Constant/RentalCustomer";

const initialState = {
  loading: false,
  data: [],
  secondData: []
};

export default function pincodeReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case GET_PINCODE_START:
      return {
        ...state,
        loading: true,
      };
    case GET_PINCODE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
      case GET_SECOND_PINCODE_SUCCESS:
        return {
          ...state,
          secondData: action.payload,
          loading: false,
        };
    case GET_PINCODE_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
      case CLEAR_PINCODE_VALUE:
        return {
          ...state,
          data: [],
          secondData:[],
          // message: action.error.message,
        };
    default:
      return state;
  }
}
